import React, { useRef, useState } from 'react';
import { ExcludedAttempt, fetchExcludedAttempts } from '../api';
import { parseServerDate } from '../model';

export const ExcludedAttemptHistory: React.FC<{ testId: number }> = ({ testId }) => {
  const [rows, setRows] = useState<ExcludedAttempt[]>([]);
  const [state, setState] = useState<'new' | 'loading' | 'ready' | 'failed'>('new');
  const requestRef = useRef(0);
  const load = async () => {
    const request = ++requestRef.current;
    setState('loading');
    try {
      const data = await fetchExcludedAttempts(testId);
      if (request !== requestRef.current) return;
      setRows(data); setState('ready');
    } catch { if (request === requestRef.current) setState('failed'); }
  };
  return (
    <details onToggle={(event) => { if (event.currentTarget.open && state === 'new') void load(); }}>
      <summary>Технические попытки — не учитываются</summary>
      {state !== 'new' && <div className="tw-stack-sm" style={{ marginTop: 12 }}>
        <p className="tw-help">Эти попытки исключены из баллов, числа неудачных прохождений и статистики. Исходные ответы сохранены.</p>
        {state === 'loading' && <p className="tw-help">Загружаем историю…</p>}
        {state === 'failed' && <><p role="alert">Не удалось загрузить историю.</p><button className="tw-btn" type="button" onClick={() => void load()}>Повторить загрузку</button></>}
        {state === 'ready' && rows.length === 0 && <p className="tw-help">Исключённых попыток нет.</p>}
        {rows.map((row) => <div className="tw-panel tw-stack-sm" key={row.attempt_id}>
          <strong>{row.user_name} · Не учитывается: технический сбой</strong>
          <p className="tw-help">Попытка №{row.attempt_id}{row.started_at ? ` · ${parseServerDate(row.started_at)?.toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' })} МСК` : ''}. Сохранено ответов: {row.saved_answers}.</p>
          <p className="tw-help">Причина: {row.reason}</p>
        </div>)}
      </div>}
    </details>
  );
};
